import {apiFuns} from "sw-hic"
let { genStandard } = apiFuns;
const api = {
  Hospitalization: genStandard("hospitalization", "/api/ip"),
  Consultation: genStandard("consultation", "/api/ip"),
  BedLog: genStandard("bedLog", "/api/ip"),
  Bed: {
    ...apiFuns.genStandard("bed", "api/ip", false, true),
  },
  Patient: genStandard("patient", "/api/patient"),
  Advice: genStandard("advice", "/api/ip"),
}

export default api;